import { InfoKey } from '@/contexts/infoPanel/model/InfoKey.enum.ts';

export type InfoEntry = {
  body: string;
  title: string;
};

export type InfoPanelTranslation = {
  closeAriaLabel: string;
  entries: Record<InfoKey, InfoEntry>;
  triggerAriaLabel: string;
  triggerTooltip: string;
};

export const infoPanelTranslation: InfoPanelTranslation = {
  closeAriaLabel: 'Zamknij',
  entries: {
    [InfoKey.PROCESS_OFFER_GROUPS]: {
      body: 'Grupa ofert spina kilka powiązanych ofert w obrębie jednego procesu. Przykładowe zastosowanie: obsługujemy wydarzenie rozłożone na kilka dni, gdzie każdy dzień rozliczamy jako osobną ofertę — wtedy tworzymy jedną grupę i dodajemy do niej tyle pozycji, ile potrzeba (np. „Dzień 1", „Dzień 2" itd.).\n\nW typowym scenariuszu — klasycznej ofercie — grupa zawiera dokładnie jedną ofertę. Struktura nie rzuca się wówczas w oczy, ale dzięki niej można w każdej chwili dorzucić kolejne warianty bez zakładania nowego procesu.\n\nW danym momencie można mieć tylko jedną aktywną grupę ofert.',
      title: 'Grupy ofert',
    },
  },
  triggerAriaLabel: 'Pokaż opis',
  triggerTooltip: 'Co to jest?',
};
